import { useEffect } from "react";
import Lenis from "lenis";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import { Nav } from "@/components/site/Nav";
import { Hero } from "@/components/site/Hero";
import { Marquee } from "@/components/site/Marquee";
import { Cycle } from "@/components/site/Cycle";
import { Nurse } from "@/components/site/Nurse";
import { Rebates } from "@/components/site/Rebates";
import { Creators } from "@/components/site/Creators";
import { Education } from "@/components/site/Education";
import { Waitlist } from "@/components/site/Waitlist";
import { Footer } from "@/components/site/Footer";
import { openBooking } from "@/lib/links";
import { CouponPopup } from "@/components/site/CouponPopup";
import AdminPage from "@/admin/AdminPage";
import { LegalPage } from "@/components/site/LegalPage";
import { PRIVACY, TERMS, UPDATED } from "@/content/legal";

const useLenis = () => {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.2, smoothWheel: true, anchors: true });
    let id;
    const raf = (t) => { lenis.raf(t); id = requestAnimationFrame(raf); };
    id = requestAnimationFrame(raf);
    return () => { cancelAnimationFrame(id); lenis.destroy(); };
  }, []);
};

function Landing() {
  useLenis();
  const book = openBooking;
  return (
    <div className="grain min-h-screen">
      <Nav onSchedule={book} />
      <main>
        <Hero onSchedule={book} />
        <Marquee />
        <Cycle onSchedule={book} />
        <Nurse onSchedule={book} />
        <Rebates onSchedule={book} />
        <Creators />
        <Education />
        <Waitlist />
      </main>
      <Footer onSchedule={book} />
      <CouponPopup onClaim={book} />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/admin" element={<AdminPage />} />
        <Route path="/privacy" element={<LegalPage {...PRIVACY} updated={UPDATED} testid="privacy-page" />} />
        <Route path="/terms" element={<LegalPage {...TERMS} updated={UPDATED} testid="terms-page" />} />
        <Route path="*" element={<Landing />} />
      </Routes>
      <Toaster theme="dark" position="bottom-center" />
    </BrowserRouter>
  );
}

export default App;
